/*
 * KAGAKI Attribution Tracker — v1.1
 *
 * Captures source/UTM/referrer/landing + behavioral session data via sessionStorage,
 * exposes window.kgAttribution.populateHiddenFields(formEl, formLocation, intentDrawn).
 *
 * No PII collected. Respects Shopify.customerPrivacy when present.
 *
 * Usage:
 *   window.kgAttribution.populateHiddenFields(form, 'footer');
 *   window.kgAttribution.populateHiddenFields(form, 'popup', currentIntentionName);
 *
 * Generated: 2026-05-14
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'kg_attribution_v1';
  var PAGES_KEY = 'kg_pages_in_session';
  var START_KEY = 'kg_session_start_ts';
  var PATH_TRAIL_KEY = 'kg_path_trail';
  var TYPE_COUNTS_KEY = 'kg_type_counts';
  var PREV_PAGE_KEY = 'kg_prev_page';
  var CURRENT_PAGE_KEY = 'kg_current_page_url';

  function canTrack() {
    if (window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.userCanBeTracked === 'function') {
      try { return window.Shopify.customerPrivacy.userCanBeTracked(); }
      catch (e) { return true; }
    }
    return true;
  }

  function getQueryParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name);
    } catch (e) { return null; }
  }

  function getPageType() {
    var path = window.location.pathname;
    if (path === '/' || path === '') return 'home';
    if (path.indexOf('/blogs/') === 0) return 'blog';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/pages/') === 0) return 'page';
    if (path.indexOf('/cart') === 0) return 'cart';
    if (path.indexOf('/account') === 0) return 'account';
    if (path.indexOf('/search') === 0) return 'search';
    return 'other';
  }

  function getPageHandle() {
    var path = window.location.pathname;
    var parts = path.split('/').filter(function (s) { return !!s; });
    if (parts.length >= 3 && parts[0] === 'blogs') return parts[2];
    if (parts.length >= 2 && (parts[0] === 'products' || parts[0] === 'collections' || parts[0] === 'pages')) return parts[1];
    return '';
  }

  function readJSON(key) {
    try { var raw = sessionStorage.getItem(key); return raw ? JSON.parse(raw) : null; }
    catch (e) { return null; }
  }
  function writeJSON(key, val) {
    try { sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function readStr(key) { try { return sessionStorage.getItem(key) || ''; } catch (e) { return ''; } }
  function writeStr(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }

  function bumpTypeCount(pageType) {
    var counts = readJSON(TYPE_COUNTS_KEY) || {};
    counts[pageType] = (counts[pageType] || 0) + 1;
    writeJSON(TYPE_COUNTS_KEY, counts);
  }

  function appendPathTrail(pageType, pageHandle) {
    var trail = readJSON(PATH_TRAIL_KEY) || [];
    var last = trail[trail.length - 1];
    var entry = { t: pageType, h: pageHandle || '', p: window.location.pathname };
    if (!last || last.p !== entry.p) {
      trail.push(entry);
      if (trail.length > 20) trail = trail.slice(-20);
      writeJSON(PATH_TRAIL_KEY, trail);
    }
  }

  function captureFirstTouch() {
    if (!canTrack()) return null;
    try {
      var pageType = getPageType();
      var pageHandle = getPageHandle();
      var existing = readJSON(STORAGE_KEY);
      if (existing) {
        var pages = parseInt(readStr(PAGES_KEY) || '0', 10) + 1;
        writeStr(PAGES_KEY, String(pages));
        var prev = readStr(CURRENT_PAGE_KEY);
        if (prev) writeStr(PREV_PAGE_KEY, prev);
        writeStr(CURRENT_PAGE_KEY, window.location.href);
        bumpTypeCount(pageType);
        appendPathTrail(pageType, pageHandle);
        return existing;
      }
      // First page of session
      var data = {
        landing_url: window.location.href,
        landing_path: window.location.pathname,
        landing_type: pageType,
        landing_handle: pageHandle,
        referrer: document.referrer || '',
        utm_source: getQueryParam('utm_source') || '',
        utm_medium: getQueryParam('utm_medium') || '',
        utm_campaign: getQueryParam('utm_campaign') || '',
        utm_content: getQueryParam('utm_content') || '',
        utm_term: getQueryParam('utm_term') || '',
        gclid: getQueryParam('gclid') || '',
        fbclid: getQueryParam('fbclid') || '',
        msclkid: getQueryParam('msclkid') || '',
        ttclid: getQueryParam('ttclid') || '',
        first_ts: new Date().toISOString()
      };
      writeJSON(STORAGE_KEY, data);
      writeStr(PAGES_KEY, '1');
      writeStr(START_KEY, String(Date.now()));
      writeStr(CURRENT_PAGE_KEY, window.location.href);
      writeStr(PREV_PAGE_KEY, '');
      var counts = {}; counts[pageType] = 1; writeJSON(TYPE_COUNTS_KEY, counts);
      writeJSON(PATH_TRAIL_KEY, [{ t: pageType, h: pageHandle, p: window.location.pathname }]);
      return data;
    } catch (e) { return null; }
  }

  function deriveSource(ft) {
    if (!ft) return 'unknown';
    if (ft.utm_source) return (ft.utm_source + '-' + (ft.utm_medium || 'unknown')).toLowerCase();
    if (ft.gclid) return 'google-cpc';
    if (ft.fbclid) return 'facebook-paid';
    if (ft.msclkid) return 'bing-cpc';
    if (ft.ttclid) return 'tiktok-paid';
    var ref = ft.referrer || '';
    if (!ref) return 'direct';
    try {
      var host = new URL(ref).hostname.replace(/^www\./, '');
      if (host.indexOf('kagaki.com') !== -1) return 'internal';
      if (host.indexOf('google.') !== -1) return 'google-organic';
      if (host.indexOf('pinterest.') !== -1) return 'pinterest-referral';
      if (host.indexOf('instagram.') !== -1) return 'instagram-referral';
      if (host.indexOf('facebook.') !== -1) return 'facebook-referral';
      if (host.indexOf('bing.') !== -1) return 'bing-organic';
      if (host.indexOf('duckduckgo.') !== -1) return 'duckduckgo-organic';
      if (host.indexOf('t.co') !== -1) return 'twitter-referral';
      if (host.indexOf('reddit.') !== -1) return 'reddit-referral';
      return host;
    } catch (e) { return 'referrer-unknown'; }
  }

  function getSessionDurationSec() {
    var start = parseInt(readStr(START_KEY) || '0', 10);
    if (!start) return 0;
    return Math.floor((Date.now() - start) / 1000);
  }
  function getPagesInSession() {
    return parseInt(readStr(PAGES_KEY) || '1', 10);
  }

  function slugify(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 30);
  }
  function safeHost(url) {
    try { return new URL(url).hostname.replace(/^www\./, ''); }
    catch (e) { return 'unknown'; }
  }

  function buildPayload(formLocation, intentDrawn) {
    var ft = captureFirstTouch() || {};
    var typeCounts = readJSON(TYPE_COUNTS_KEY) || {};
    var trail = readJSON(PATH_TRAIL_KEY) || [];
    return {
      schema_version: '1.1',
      ts: new Date().toISOString(),
      form: formLocation,
      page: {
        url: window.location.href,
        type: getPageType(),
        handle: getPageHandle()
      },
      previous_page: readStr(PREV_PAGE_KEY),
      landing: {
        url: ft.landing_url || '',
        type: ft.landing_type || '',
        handle: ft.landing_handle || '',
        ts: ft.first_ts || ''
      },
      referrer: ft.referrer || '',
      utm: {
        source: ft.utm_source || '',
        medium: ft.utm_medium || '',
        campaign: ft.utm_campaign || '',
        content: ft.utm_content || '',
        term: ft.utm_term || ''
      },
      click_ids: {
        gclid: ft.gclid || '',
        fbclid: ft.fbclid || '',
        msclkid: ft.msclkid || '',
        ttclid: ft.ttclid || ''
      },
      session: {
        pages_viewed: getPagesInSession(),
        duration_sec: getSessionDurationSec(),
        blog_views: typeCounts.blog || 0,
        product_views: typeCounts.product || 0,
        collection_views: typeCounts.collection || 0,
        page_views: typeCounts.page || 0,
        home_views: typeCounts.home || 0,
        path_trail: trail
      },
      intent: intentDrawn || '',
      coupon: formLocation === 'popup' ? 'FOUNDYOU20' : ''
    };
  }

  function deriveTags(payload) {
    var tags = [];
    tags.push('src_' + payload.form);
    if (payload.utm.source) tags.push('utm_src_' + slugify(payload.utm.source));
    if (payload.utm.medium) tags.push('utm_med_' + slugify(payload.utm.medium));
    if (payload.utm.campaign) tags.push('utm_camp_' + slugify(payload.utm.campaign).slice(0, 20));
    var refHost = payload.referrer ? safeHost(payload.referrer) : 'direct';
    tags.push('ref_' + slugify(refHost));
    tags.push('page_' + payload.page.type);
    if (payload.intent) tags.push('intent_' + slugify(payload.intent));
    return tags;
  }

  function populateHiddenFields(formEl, formLocation, intentDrawn) {
    if (!formEl) return null;
    var payload = buildPayload(formLocation, intentDrawn);
    var tags = deriveTags(payload);

    function setField(name, value) {
      var input = formEl.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        formEl.appendChild(input);
      }
      input.value = value == null ? '' : String(value);
    }

    // Individual hidden fields (theme can read individually if desired)
    setField('contact[kg_form_location]', payload.form);
    setField('contact[kg_landing_url]', payload.landing.url);
    setField('contact[kg_landing_type]', payload.landing.type);
    setField('contact[kg_landing_handle]', payload.landing.handle);
    setField('contact[kg_page_url]', payload.page.url);
    setField('contact[kg_page_type]', payload.page.type);
    setField('contact[kg_page_handle]', payload.page.handle);
    setField('contact[kg_previous_page]', payload.previous_page);
    setField('contact[kg_referrer]', payload.referrer);
    setField('contact[kg_utm_source]', payload.utm.source);
    setField('contact[kg_utm_medium]', payload.utm.medium);
    setField('contact[kg_utm_campaign]', payload.utm.campaign);
    setField('contact[kg_utm_content]', payload.utm.content);
    setField('contact[kg_utm_term]', payload.utm.term);
    setField('contact[kg_gclid]', payload.click_ids.gclid);
    setField('contact[kg_fbclid]', payload.click_ids.fbclid);
    setField('contact[kg_pages_in_session]', payload.session.pages_viewed);
    setField('contact[kg_duration_sec]', payload.session.duration_sec);
    setField('contact[kg_blog_views]', payload.session.blog_views);
    setField('contact[kg_product_views]', payload.session.product_views);
    setField('contact[kg_collection_views]', payload.session.collection_views);
    setField('contact[kg_intent_drawn]', payload.intent);

    // Append JSON to contact[note] after attribution separator
    var noteInput = formEl.querySelector('input[name="contact[note]"], textarea[name="contact[note]"]');
    var existingNote = noteInput ? (noteInput.value || '') : '';
    var jsonStr = '';
    try { jsonStr = JSON.stringify(payload); } catch (e) { jsonStr = ''; }
    var newNote = existingNote
      ? (existingNote + '\n--- attribution v1 ---\n' + jsonStr)
      : ('--- attribution v1 ---\n' + jsonStr);
    if (noteInput) {
      noteInput.value = newNote;
    } else {
      setField('contact[note]', '--- attribution v1 ---\n' + jsonStr);
    }

    // Merge tags into contact[tags] preserving existing
    var tagsInput = formEl.querySelector('input[name="contact[tags]"]');
    if (tagsInput) {
      var existingTags = (tagsInput.value || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      var combinedMap = {};
      existingTags.concat(tags).forEach(function (t) { combinedMap[t] = true; });
      var combined = Object.keys(combinedMap).slice(0, 15);
      tagsInput.value = combined.join(',');
    } else {
      setField('contact[tags]', tags.slice(0, 15).join(','));
    }

    // Fire GA4 event if gtag present — NO PII
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'generate_lead', {
          method: 'newsletter_' + formLocation,
          form_location: formLocation,
          landing_page: payload.landing.url,
          landing_type: payload.landing.type,
          landing_handle: payload.landing.handle,
          page_type: payload.page.type,
          page_handle: payload.page.handle,
          page_referrer: payload.referrer,
          utm_source: payload.utm.source,
          utm_medium: payload.utm.medium,
          utm_campaign: payload.utm.campaign,
          utm_content: payload.utm.content,
          utm_term: payload.utm.term,
          intent_drawn: payload.intent,
          pages_viewed: payload.session.pages_viewed,
          blog_views: payload.session.blog_views,
          product_views: payload.session.product_views,
          collection_views: payload.session.collection_views,
          session_duration_sec: payload.session.duration_sec
        });
      } catch (e) { /* gtag failure must never break signup */ }
    }
    return payload;
  }

  // Fire on every page load — establish or extend session
  captureFirstTouch();

  // Expose API
  window.kgAttribution = {
    populateHiddenFields: populateHiddenFields,
    buildPayload: buildPayload,
    deriveSource: deriveSource,
    getFirstTouch: function () { return readJSON(STORAGE_KEY) || {}; },
    getSession: function () {
      return {
        pages: getPagesInSession(),
        duration_sec: getSessionDurationSec(),
        type_counts: readJSON(TYPE_COUNTS_KEY) || {},
        path_trail: readJSON(PATH_TRAIL_KEY) || [],
        previous_page: readStr(PREV_PAGE_KEY)
      };
    }
  };
})();
